var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropbox',{attrs:{"name":"dependent","label":"Para quem é o atendimento:","items":_vm.dependents,"value":_vm.value,"required":_vm.required},on:{"input":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }